import { firstValueFrom } from 'rxjs';
import { config } from '@core/interfaces/api_baseurl';
import { APP_INITIALIZER, inject, Provider } from '@angular/core';
import { ENC_DOMAIN_NAME } from '@core/services/domain-name.token';
import { ENCRYPTION_MODE, ENCRYPTION_MODE_TYPE } from './encryption-mode';
import { LOCATION_READY } from '@core/location-required/location-required.factory';
import { ApiService } from '@core/auth/auth.service';

export function initEncryption(_ApiService: ApiService, _ENC_DOMAIN_NAME: string, ENCRYPTION_MODE: ENCRYPTION_MODE_TYPE,
    locationReady: Promise<void>) {
    return async () => {
        await locationReady;
        const domainKey: string = _ENC_DOMAIN_NAME;

        try {
            const response: any = await firstValueFrom(
                _ApiService.post(config.auth.getEncryptionMode, { 'niamod': domainKey })
            );

            // const encryptionMode = !response?.data?.encrypt;
            const encryptionMode = response?.data?.encrypt as 0 | 1 ?? 0;
            ENCRYPTION_MODE.set(+encryptionMode as 0 | 1);

        } catch (err) {
            ENCRYPTION_MODE.set(0);
            console.error('[Encryption Init] Failed:', err);
        }
    };
}



export const ENCRYPTION_INITIALIZER: Provider = {
    provide: APP_INITIALIZER,
    useFactory: () => initEncryption(inject(ApiService), inject(ENC_DOMAIN_NAME), inject(ENCRYPTION_MODE), inject(LOCATION_READY)),
    multi: true
};